export default __webpack_public_path__ + "static/media/element3.2b4f2d97.svg";